import React from 'react';
import { TooltipProps } from 'recharts';
import { DataPoint, FroudVsRejection } from '../../../../dto/Interfaces/FrontendAnalytics/IFrontendAnalytics';
import { TooltipElement } from '../TooltipBody';

const CustomTooltip: React.FC<TooltipProps<number, string> & { fvsr: FroudVsRejection[] }> = ({ active, payload, fvsr }) => {
  if (active && payload && payload.length) {
    const { x, y } = payload[0]?.payload as DataPoint;
    const score = fvsr.find((el) => el.fdr === x)?.s;
    return (
      <TooltipElement className="custom-tooltip">
        <p>{`Fraud detection rate: ${x}%`}</p>
        <p>{`Approval reduction rate: ${y}%`}</p>
        <p>{`Score: ${score || '0'}`}</p>
      </TooltipElement>
    );
  }

  return null;
};

export default CustomTooltip;
